function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useRef, createContext, useContext, useMemo } from 'react';
import { guid, isArray, isAssigned, isFunction } from '@okee-uikit/react-utils';
import { useSelectionMultiple, useSelectionSingle } from '@okee-uikit/react-hooks';
import { Button } from '../../button';
import { Popover } from '../../popover';
import { Checkbox } from '../../checkbox';
import { Right } from '../../../common/icons';
import { Radio } from '../../radio';
import { useClearTableColumn } from './column';
export var selectionColumnId = guid();

function getAllIdsRecursively(rowInfos) {
  var ids = [];
  rowInfos.forEach(function (row) {
    var id = row.id,
        children = row.children,
        _row$compProps = row.compProps;
    _row$compProps = _row$compProps === void 0 ? {} : _row$compProps;
    var disabled = _row$compProps.disabled;
    !disabled && ids.push(id);

    if (children) {
      ids.push.apply(ids, _toConsumableArray(getAllIdsRecursively(children)));
    }
  });
  return ids;
}

export function useTableSelectionInit(options) {
  var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isAssigned(options);

  var _ref = options || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'multiple' : _ref$type,
      componentProps = _ref.componentProps,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      controlled = _ref.controlled;

  var optionsRef = useRef({});
  optionsRef.current = options || {};
  var selectionOptions = {
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    controlled: controlled
  };

  var _useSelectionMultiple = useSelectionMultiple(type === 'multiple' && selectionOptions || {}),
      _useSelectionMultiple2 = _slicedToArray(_useSelectionMultiple, 2),
      multiple = _useSelectionMultiple2[0],
      multipleActions = _useSelectionMultiple2[1];

  var _useSelectionSingle = useSelectionSingle(type === 'single' && selectionOptions || {}),
      _useSelectionSingle2 = _slicedToArray(_useSelectionSingle, 2),
      single = _useSelectionSingle2[0],
      singleActions = _useSelectionSingle2[1];

  var _ref2 = type === 'multiple' && [multiple, multipleActions] || type === 'single' && [single, singleActions] || [undefined, undefined],
      _ref3 = _slicedToArray(_ref2, 2),
      selected = _ref3[0],
      selectionActions = _ref3[1];

  var clearColumn = useClearTableColumn(options || {});
  var selectionColumn = useMemo(function () {
    if (!enable) {
      return undefined;
    }

    var column = _objectSpread(_objectSpread({
      widthFixed: true,
      fixed: 'left'
    }, clearColumn), {}, {
      id: selectionColumnId
    });

    if (isFunction(column.render)) {
      column.width = column.width || 48;
      return column;
    }

    switch (type) {
      case 'multiple':
        {
          column.width = column.width || 48;

          if (!column.title) {
            column.title = function (_ref4) {
              var original = _ref4.original,
                  current = _ref4.current,
                  selected = _ref4.selected,
                  selectionActions = _ref4.selectionActions;
              var actions = selectionActions;

              var selectAll = function selectAll() {
                return actions.setValue(getAllIdsRecursively(original));
              };

              var unselectAll = function unselectAll() {
                return actions.setValue([]);
              };

              var selectAllCurrent = function selectAllCurrent() {
                return actions.select(getAllIdsRecursively(current));
              };

              var unselectAllCurrent = function unselectAllCurrent() {
                return actions.unselect(getAllIdsRecursively(current));
              };

              var allDisabledCurrent = isAllDisabledRecursively(current);
              var allSelectedCurrent = isAllSelectedRecursively(current, allDisabledCurrent, actions);
              var indeterminate = !allSelectedCurrent && isArray(selected) && selected.length > 0;

              var onChange = function onChange() {
                if (indeterminate) {
                  selectAllCurrent();
                  return;
                }

                if (allSelectedCurrent) {
                  unselectAllCurrent();
                } else {
                  selectAllCurrent();
                }
              };

              var dropdown = React.createElement(Popover, {
                trigger: "hover",
                placement: "bottom-start",
                hideToDestroy: true,
                getPopper: function getPopper() {
                  return React.createElement("div", {
                    style: {
                      display: 'flex',
                      flexFlow: 'column nowrap',
                      alignItems: 'stretch'
                    }
                  }, React.createElement(Button, {
                    type: "text",
                    onClick: optionsRef.current.onSelectAllCurrent || selectAllCurrent
                  }, "\u9009\u62E9\u5F53\u9875"), React.createElement(Button, {
                    type: "text",
                    onClick: optionsRef.current.onSelectAll || selectAll
                  }, "\u5168\u9009\u6240\u6709"), React.createElement(Button, {
                    type: "text",
                    onClick: optionsRef.current.onUnselectAllCurrent || unselectAllCurrent
                  }, "\u91CD\u7F6E\u5F53\u9875"), React.createElement(Button, {
                    type: "text",
                    onClick: optionsRef.current.onUnselectAll || unselectAll
                  }, "\u91CD\u7F6E\u6240\u6709"));
                }
              }, React.createElement(Right, {
                className: "foobar",
                style: {
                  lineHeight: '22px',
                  transform: 'rotate(90deg)'
                }
              }));
              return React.createElement("div", {
                style: {
                  whiteSpace: 'nowrap'
                }
              }, React.createElement(Checkbox, {
                disabled: allDisabledCurrent,
                checked: allSelectedCurrent,
                indeterminate: indeterminate,
                onChange: onChange
              }));
            };
          }

          column.render = function (row, info) {
            var selection = info.selection,
                compProps = info.compProps;
            var selected = selection.selected,
                toggle = selection.toggle;
            return React.createElement(Checkbox, _objectSpread({
              checked: selected,
              onChange: toggle
            }, compProps));
          };
        }
        break;

      case 'single':
        {
          column.width = column.width || 48;

          column.render = function (row, info) {
            var selection = info.selection,
                compProps = info.compProps;
            var selected = selection.selected,
                select = selection.select;
            return React.createElement(Radio, _objectSpread({
              checked: selected,
              onChange: select
            }, compProps));
          };
        }
        break;

      default:
        column.width = column.width || 48;
    }

    return column;
  }, [enable, type, selected, selectionActions, clearColumn]);
  return [selected, selectionActions, selectionColumn];
}
export var SelectionContext = createContext({
  selected: undefined,
  actions: undefined
});
export var useTableSelection = function useTableSelection() {
  return useContext(SelectionContext);
};
export function isAllSelectedRecursively(rowInfos, allDisabled, actions) {
  return !!rowInfos.length && rowInfos.every(function (r) {
    var _a;

    return !allDisabled && ((_a = r.compProps) === null || _a === void 0 ? void 0 : _a.disabled) || actions.isSelected(r.id) && (r.children && r.children.length ? isAllSelectedRecursively(r.children, allDisabled, actions) : true);
  });
}
export function isAllDisabledRecursively(rowInfos) {
  return !rowInfos.length || rowInfos.every(function (r) {
    var _a;

    return ((_a = r.compProps) === null || _a === void 0 ? void 0 : _a.disabled) && (!r.children || isAllDisabledRecursively(r.children));
  });
}